/**
 * A collection of general helpers for statistical calculations
 */

export const average = (values: number[]): number =>
  values.length === 0
    ? 0
    : values.reduce((sum, value) => sum + value, 0) / values.length
